import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
  Button,
  InlineNotification,
  Text,
} from "@coreai/component-library";
import { useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

interface DeleteProjectDialogProps {
  project: any;
  open: boolean;
  onClose: () => void;
  onDelete: (id: string) => void;
}

export default function DeleteProjectDialog(
  props: Readonly<DeleteProjectDialogProps>
) {
  const { t } = useLanguage();
  const theme = useTheme();

  const alertDialogBodyStyles = {
    border: "none",
  } as React.CSSProperties;

  const bodyStyles = {
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textDark,
    marginBottom: theme.spacing.sm,
    paddingTop: 0,
    overflowY: "visible",
    gap: "1.5rem",
  } as React.CSSProperties;

  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(isOpen) => !isOpen && props.onClose()}
    >
      <AlertDialogContent size="sm">
        <AlertDialogHeader style={alertDialogBodyStyles}>
          <AlertDialogTitle>
            {t("project_removeProject_title")}
          </AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogBody style={bodyStyles}>
          <Text style={bodyStyles}>
            {t("project_removeProject_paragraph", {
              projectName: props.project?.name,
              advertiserName: props.project?.advertiser,
            })}
          </Text>

          <InlineNotification
            close
            description={t("project_removeProject_inlineInformation_text", {
              n: props.project?.total_analysis,
            })}
            title={t("project_removeProject_inlineInformation_title")}
            variant="error"
          />
        </AlertDialogBody>

        <AlertDialogFooter style={alertDialogBodyStyles}>
          <AlertDialogCancel asChild>
            <Button variant="tertiary">{t("core_cancel")}</Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant={"brand"}
              style={{ backgroundColor: theme.colors.primary }}
              onClick={() => props.onDelete(props.project.id)}
              className="brandPrimaryBtn"
            >
              {t("core_delete")}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
